var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import { BContainer, BRow, BCol, BCard, BImg } from 'bootstrap-vue';
import measuringImg from '@/img/measuring-frame-for-mount.jpg';
import measuringCloseupImg from '@/img/measuring-frame-for-mount-closeup.jpg';
import doubleMountExampleOneImg from '@/img/double-picture-mount-example-1.jpg';
import doubleMountExampleTwoImg from '@/img/double-picture-mount-example-2.jpg';
import doubleMountExampleThreeImg from '@/img/double-picture-mount-example-3.jpg';
import mountslipExampleOneImg from '@/img/mountslip-example-1.jpg';
import mountslipExampleTwoImg from '@/img/mountslip-example-2.jpg';
import multiApExampleOneImg from '@/img/multi-aperture-picture-mount-example-1.jpg';
import multiApExampleTwoImg from '@/img/multi-aperture-picture-mount-example-2.jpg';
import multiApExampleThreeImg from '@/img/multi-aperture-picture-mount-example-3.jpg';
var BuyingGuide = /** @class */ (function (_super) {
    __extends(BuyingGuide, _super);
    function BuyingGuide() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.measuringImg = measuringImg;
        _this.measuringImgWebp = measuringImg.replace('.jpg', '.webp');
        _this.measuringCloseupImg = measuringCloseupImg;
        _this.measuringCloseupImgWebp = measuringCloseupImg.replace('.jpg', '.webp');
        _this.doubleMountExampleOneImg = doubleMountExampleOneImg;
        _this.doubleMountExampleOneImgWebp = doubleMountExampleOneImg.replace('.jpg', '.webp');
        _this.doubleMountExampleTwoImg = doubleMountExampleTwoImg;
        _this.doubleMountExampleTwoImgWebp = doubleMountExampleTwoImg.replace('.jpg', '.webp');
        _this.doubleMountExampleThreeImg = doubleMountExampleThreeImg;
        _this.doubleMountExampleThreeImgWebp = doubleMountExampleThreeImg.replace('.jpg', '.webp');
        _this.mountslipExampleOneImg = mountslipExampleOneImg;
        _this.mountslipExampleOneImgWebp = mountslipExampleOneImg.replace('.jpg', '.webp');
        _this.mountslipExampleTwoImg = mountslipExampleTwoImg;
        _this.mountslipExampleTwoImgWebp = mountslipExampleTwoImg.replace('.jpg', '.webp');
        _this.multiApExampleOneImg = multiApExampleOneImg;
        _this.multiApExampleOneImgWebp = multiApExampleOneImg.replace('.jpg', '.webp');
        _this.multiApExampleTwoImg = multiApExampleTwoImg;
        _this.multiApExampleTwoImgWebp = multiApExampleTwoImg.replace('.jpg', '.webp');
        _this.multiApExampleThreeImg = multiApExampleThreeImg;
        _this.multiApExampleThreeImgWebp = multiApExampleThreeImg.replace('.jpg', '.webp');
        return _this;
    }
    BuyingGuide = __decorate([
        Component({
            components: {
                BContainer: BContainer,
                BRow: BRow,
                BCol: BCol,
                BCard: BCard,
                BImg: BImg
            },
            metaInfo: {
                title: 'Picture & Photo Mount Buying Guide - ePictureMounts',
                meta: [
                    {
                        name: 'description',
                        content: 'Your essential guide to purchasing the perfect picture mount to fit your artwork, photograph or any other item. From how to measure your item to find the size of mountboard you require, to choosing the correct colour to make your item really stand out.'
                    },
                    {
                        name: 'keywords',
                        content: 'measuring guide, buying guide, picture mounts, photo mounts, mountboard colours, double mounts, triple mounts, mountslips'
                    }
                ]
            }
        })
    ], BuyingGuide);
    return BuyingGuide;
}(Vue));
export default BuyingGuide;
